import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import './EFakturaCreditor.scss';

const EFakturaCreditorSkeleton: React.FC = () => {
    return (
        <li className="efaktura-creditor">
            <DarkSkeleton height={26} width={200} />
        </li>
    );
};

export default EFakturaCreditorSkeleton;
